import { animate, style, transition, trigger } from '@angular/animations';

/**
 * Form animations for Angular components.
 *
 * LEGACY (deprecated in Angular 20, removed in v23):
 *   animations: [FormAnimations.ShowButtons]
 *   Template: <div @showButtons>
 *
 * NEW (Angular 20+):
 *   Template: [animate.enter]="'form-show-buttons-enter'" [animate.leave]="'form-show-buttons-leave'"
 *   (requires _form-animations.scss to be imported in global styles)
 */
export class FormAnimations {
    // Legacy animations (deprecated, will be removed in Angular v23)
    // eslint-disable-next-line deprecation/deprecation
    public static readonly ShowButtons =
        // eslint-disable-next-line deprecation/deprecation
        trigger('showButtons', [
            // eslint-disable-next-line deprecation/deprecation
            transition(':enter', [
                // eslint-disable-next-line deprecation/deprecation
                style({ opacity: 0 }),
                // eslint-disable-next-line deprecation/deprecation
                animate(300, style({ opacity: 1 }))
            ]),
            // eslint-disable-next-line deprecation/deprecation
            transition(':leave', [
                // eslint-disable-next-line deprecation/deprecation
                style({ opacity: 1 }),
                // eslint-disable-next-line deprecation/deprecation
                animate(300, style({ opacity: 0 }))
            ])
        ]);

    // eslint-disable-next-line deprecation/deprecation
    public static readonly AnimateDisplay =
        // eslint-disable-next-line deprecation/deprecation
        trigger('animateDisplay', [
            // eslint-disable-next-line deprecation/deprecation
            transition(':enter', [
                // eslint-disable-next-line deprecation/deprecation
                style({ opacity: 0 }),
                // eslint-disable-next-line deprecation/deprecation
                animate(500, style({ opacity: 1 }))
            ]),
            // eslint-disable-next-line deprecation/deprecation
            transition(':leave', [
                // eslint-disable-next-line deprecation/deprecation
                style({ opacity: 1 }),
                // eslint-disable-next-line deprecation/deprecation
                animate(200, style({ opacity: 0 }))
            ])
        ]);

    // New CSS class names for Angular 20+ animate.enter/leave
    public static readonly ShowButtonsEnter = 'form-show-buttons-enter';
    public static readonly ShowButtonsLeave = 'form-show-buttons-leave';
    public static readonly AnimateDisplayEnter = 'form-animate-display-enter';
    public static readonly AnimateDisplayLeave = 'form-animate-display-leave';
}
